import { Capacitor } from '@capacitor/core';
import { SplashScreen } from '@capacitor/splash-screen';

export async function hideSplash() {
  if (!Capacitor.isNativePlatform()) return;
  try {
    await SplashScreen.hide({ fadeOutDuration: 300 });
  } catch {}
}

export function startSplashFallback() {
  if (!Capacitor.isNativePlatform()) return;
  setTimeout(hideSplash, 5000);
}
